import React, { useEffect } from 'react';

const ContainerBaseUser = (props) =>{
    
// useEffect(() => {
//     const broadcastChannel = new BroadcastChannel('two-tabs-validator');
//     const TAB_ID = window.crypto.getRandomValues(new Uint32Array(1))[0];
//     broadcastChannel.onmessage = (event) => {
//         // console.log(event.data)
//     if (event.data.type === 'check') {
//             broadcastChannel.postMessage({
//                 type: 'valid', 
//                 data: TAB_ID
//             });
//         }
//     };
    
//     window.addEventListener('unload', () => {
//     broadcastChannel.postMessage({
//     type: 'unregister'
//     });
//     broadcastChannel.close();
//     });
    
// }, [])

    return(
        <>
        <section className="baseBodyUser">
            <div className="bodyUser--container-header">
                {props.header}
            </div>
            <div className="bodyUser--container-main">
                {props.main}
            </div>
            <div className="bodyUser--container-footer">
                {props.footer}
            </div> 
        </section>
        <div id="contSh" className='contSh'>
        

        <section className="baseShadowUser">
        </section>
        </div>
        </>
    );
}

export default ContainerBaseUser;